const testIds = {
  map: {
    hokkaido: {
      hokkaido: 'hokkaido',
    },
    tohoku: {
      iwate: 'iwate',
      akita: 'akita',
      aomori: 'aomori',
      yamagata: 'yamagata',
      miyagi: 'miyagi',
      fukushima: 'fukushima',
    },
    kanto: {
      ibaraki: 'ibaraki',
      tochigi: 'tochigi',
      gunma: 'gunma',
      chiba: 'chiba',
      saitama: 'saitama',
      kanagawa: 'kanagawa',
      tokyo: 'tokyo',
    },
    chubu: {
      ishikawa: 'ishikawa',
      toyama: 'toyama',
      yamanashi: 'yamanashi',
      nigata: 'nigata',
      'nigata-sado-island': 'nigata-sado-island',
      aichi: 'aichi',
      fukui: 'fukui',
      gifu: 'gifu',
      nagano: 'nagano',
      shizuoka: 'shizuoka',
    },
    chugoku: {
      hiroshima: 'hiroshima',
      okayama: 'okayama',
      shimane: 'shimane',
      yamaguchi: 'yamaguchi',
      tottori: 'tottori',
    },
    kansai: {
      hyogo: 'hyogo',
      hyogoAwajiIsland: 'hyogoAwajiIsland',
      mie: 'mie',
      wakayama: 'wakayama',
      kyoto: 'kyoto',
      shiga: 'shiga',
      nara: 'nara',
      osaka: 'osaka',
    },
    shikoku: {
      kochi: 'kochi',
      ehime: 'ehime',
      tokushima: 'tokushima',
      kagawa: 'kagawa',
    },
    kyushu: {
      miyazaki: 'miyazaki',
      kagoshima: 'kagoshima',
      kumamoto: 'kumamoto',
      oita: 'oita',
      fukuoka: 'fukuoka',
      saga: 'saga',
      nagasaki: 'nagasaki',
    },
    okinawa: {
      okinawa: 'okinawa',
      okinawaMiyagiIsland: 'okinawaMiyagiIsland',
    },
  },
  mapCard: {
    mapCardHeaderTitleText: 'mapCardHeaderTitleText',
    mapCardPrefectureText: 'mapCardPrefectureText',
  },
};

export default testIds;
